import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 28px;
  background: var(--filter-bar-bg);
  flex-wrap: wrap;
  row-gap: 10px;
  justify-content: end;
  gap: 10px;
  button {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 13px;
    border: 1px solid var(--filter-bar-btn-border);
    border-radius: 30px;
    background-color: transparent;
    min-height: 30px;
    color: var(--theme-text);
    min-width: 31px;
    justify-content: center;
    padding: 0 15px;
  }
  .MuiInputBase-input {
    padding: 6.5px 14px;
    background: #fff;
    font-size: 13px;
    line-height: 150%;
  }
`;
export const FormWraper = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding-top: 12px;
  padding-right: 21px;
`;
export const Container = styled.div``;

export const BodyContainer = styled.div`
  padding: 22px 21px;
  .header-checkbox {
    margin: 14px 28px 21px;
    .MuiTypography-root {
      font-family: "latosemibold";
    }
  }
`;

export const Heading = styled.div`
  font-size: 16px;
  line-height: 150.5%;
  padding: 13px 28px;
  background: var(--box-header-background);
  color: var(--text-primary);
  margin-bottom: 26px;
  font-family: "latobold";
  border: var(--box-header-border);
`;

export const DaysWrapper = styled.div`
  background: #ffffff;
  border: 1px solid #e7e7e7;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 23px 28px;
  display: flex;
  align-items: center;
  gap: 15px 70px;
  flex-wrap: wrap;
  .checkbox {
    .MuiTypography-root {
      font-family: "latosemibold";
    }
  }
  @media (max-width: 550px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px 30px;

  }
  @media (max-width: 374px) {
    grid-template-columns: 1fr;

  }
`;

export const ActionBtn = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 28px;
  padding: 0;
  button {
    display: flex;
    font-size: 13px;
    line-height: 150.5%;
    color: #1d1d1d;
    padding: 5px 15px;
    border: 1px solid #636f7c;
    border-radius: 30px;
    align-items: center;
    gap: 5px;
    background-color: #fff;
    font-family: "latoregular";
    white-space: nowrap;
    text-transform: capitalize;
    &.disabled {
      color:rgba(0, 0, 0, 0.26);
      pointer-events: none; 
      .icon {
        opacity: 0.5;
      }
    }
    &.active {
      background: rgb(188,155,106);
    color: rgb(255,255,255);
    border-color: transparent;
    }
  }
`;
